import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import { toast } from "@/hooks/use-toast"
import { getApiErrorMessage } from "@/lib/api-error"

export type RemoveRepicRetryRequest = {
  id: string
  count: number
}

export const removeRepicRetry = async (
  { id, count }: RemoveRepicRetryRequest,
  whiteLabelUuid: string
) => {
  const url = `${ENDPOINTS.REPIC_CONFIGURATION}/${id}/remove-retry/${count}/count`
  const { data } = await api.delete(url, {
    headers: {
      "x-white-label-uuid": whiteLabelUuid,
    },
  })
  return data
}

export const useRemoveRepicRetry = () => {
  const queryClient = useQueryClient()
  const { selectedWhiteLabel } = useAuth()
  const whiteLabelUuid = selectedWhiteLabel?.uuid

  return useMutation<
    unknown,
    unknown,
    RemoveRepicRetryRequest
  >({
    mutationFn: async (payload: RemoveRepicRetryRequest) =>
      removeRepicRetry(payload, whiteLabelUuid as string),
    onSuccess: () => {
      toast({
        title: "Dia removido com sucesso",
        variant: "success",
      })

      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] ===
          ENDPOINTS.REPIC_CONFIGURATION,
      })
    },
    onError: (error: unknown) => {
      toast({
        title: getApiErrorMessage(
          error,
          "Erro ao remover dia"
        ),
        variant: "destructive",
      })
    },
  })
}

export default useRemoveRepicRetry
